<template>
    <div class="stepBox clear">
        <div class="stepItem fl" :class="{xz: item.key == index}" v-for="item in stepItem" :key="item.key">
            <p class="stepIndex">{{item.key}}</p>
            <p class="stepTitle">{{item.title}}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['index'],
    data() {
        return {
            stepItem: [
                {
                    key: 1,
                    title: '注册账号'
                }, {
                    key: 2,
                    title: '填写基本信息'
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.stepBox{
    color: rgba(124, 124, 151, 1);
    font-size: 16px;
    width: 280px;
    margin: 0 auto 67px;
    padding-top: 62px;
    .stepIndex{
        width: 26px;
        height: 26px;
        border-radius: 50%;
        background-color: rgba(43, 43, 70, 1);
        text-align: center;
        line-height: 26px;
        margin: 0 auto 18px;
    }
    .stepItem.xz{
        .stepIndex{
            background: linear-gradient(132deg, #5455FF 0%, #5484FF 100%);
            box-shadow: 0px 4px 13px 0px rgba(84, 122, 255, 0.31);
            color: #fff;
        }
        .stepTitle{
            color: #fff;
        }
    }
    .stepItem:nth-child(1){
        margin-right: 120px;
        position: relative;
    }
    .stepItem:nth-child(1):after{
        content: '';
        width: 172px;
        height: 2px;
        position: absolute;
        left: 47px;
        top: 12px;
        background: linear-gradient(149deg, rgba(40, 40, 58, 0) 0%, rgba(40, 40, 58, 1) 50%, rgba(40, 40, 58, 0) 100%);
    }
}
</style>
